/* ==========================================================================
   PanelAccommodation > Client > Store > Reducer
   ========================================================================== */

/* Modules */
const { types } = require('./actions');

/* Initial state */
const initialState = {
    totalRooms: 0,
    totalPeople: 0,
    errorMessage: '',
    error: false,
    infoMessage: '',
    hasInfo: false,
    messageType: false,
    rooms: []
};

/* Reducer */
function reducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_DATA:
            return {
                ...state,
                totalRooms: action.payload.length,
                rooms: action.payload,
                totalPeople: action.payload.map(room => room.total).reduce((acc, val) => acc + val, 0)
            };
        case types.ADD_ROOM:
            return {
                ...state,
                totalRooms: state.totalRooms + 1
            };
        case types.REMOVE_ROOM:
            return {
                ...state,
                totalRooms: state.totalRooms - 1
            };
        case types.UPDATE_ROOMS:
            return {
                ...state,
                rooms: action.payload,
                totalPeople: action.payload.map(room => room.total).reduce((acc, val) => acc + val)
            };
        case types.SET_ERROR:
            return {
                ...state,
                error: true,
                errorMessage: action.payload || state.error
            };
        case types.SET_VALID:
            return {
                ...state,
                error: false,
                errorMessage: null
            };
        case types.SET_INFO:
            return {
                ...state,
                hasInfo: true,
                infoMessage: action.payload || state.infoMessage
            };
        case types.REMOVE_INFO:
            return {
                ...state,
                hasInfo: false,
                infoMessage: ''
            };
        case types.DESTROY:
        default:
            return state;
    }
}

/* Exports */
module.exports = {
    reducer
};
